import React, { useCallback, useEffect, useRef, useState } from 'react';
// import { Cloudinary } from '@cloudinary/url-gen';
// import { AdvancedVideo } from '@cloudinary/react';

// import React, { HTMLAttributeReferrerPolicy, LegacyRef, RefAttributes, useCallback, useEffect, useRef, useState } from 'react';
// import MenuItem from '../components/MenuItem';
import { NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import '../App.css';
// import ReactPlayer from 'react-player';
// import { Post } from '../core/lib/types';
import Auth from '../core/services/auth';
import { ToastContainer, toast } from 'react-toastify';

import  IconBackComponent from '../components/IconBackComponent';
// import  IconLikeComponent from '../components/IconLikeComponent';
// import  IconPinComponent from '../components/IconPinComponent';
// import  IconShareComponent from '../components/IconShareComponent';
// import  IconMoreComponent from '../components/IconMoreComponent';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import _ from 'lodash';

// import InfiniteScroll from 'react-infinite-scroll-component';
// import PostViewComponent from '../components/PostViewComponent';
// import { Post } from '../core/lib/types';
 
import { FixedSizeList as List } from 'react-window';
// import AutoSizer from 'react-virtualized-auto-sizer';
import ReactTimeAgo from 'react-time-ago'

import Marquee from "react-fast-marquee";
import Avatar from 'react-avatar';
import handleViewport, { type InjectedViewportProps } from 'react-in-viewport';
import InfiniteLoader from 'react-window-infinite-loader'
import PageLoader from '../components/PageLoader';
import { getMediaStreamURL, getVideoThumb } from '../core/lib/utils';

const Block = (props: InjectedViewportProps<HTMLDivElement>) => {
  const { forwardedRef } = props;
//   inViewport
//   const color = inViewport ? '#217ac0' : '#ff9800';
//   const text = inViewport ? 'In viewport' : 'Not in viewport';
  return (
    <div onDoubleClick={e=>e.preventDefault()}  className=" inset-x-0 bottom-0" ref={forwardedRef}>
      {/* <h3>{ text }</h3> */}
      {/* <div style={{ width: '400px', height: '300px', background: color }} /> */}
    </div>
  );
};

// const cld = new Cloudinary({
//   cloud: {
//     cloudName: 'dttxqjchu'
//   }
// });

const ViewportBlock = handleViewport(Block, /** options: {}, config: {} **/);


function PostView(this: any) {
    const listRef = useRef<any>(null);
    const [isLastVideoVisible, setIsLastVideoVisible] = useState(false);

    const [ mute, setMute ] = useState(Auth.getMuted() !== "undefined" ? Auth.getMuted() === 'true' ? true : false : false)
    // const ref = useRef<any>();
    // const [isPlaying, setIsPlaying] = useState(false);
    // const [isLoaded, setIsLoaded] = useState(false);

    const navigate = useNavigate();
    const { state } = useLocation();
    // const [ data, setData ] = useState([])
    const [height, setHeight] = useState(window.innerHeight);
    const [width, setWidth] = useState(window.innerWidth);
    const [ report, setReport ] = useState('');
    const [ reportId, setReportId ] = useState('');
    const [ openReport, setOpenReport ] = useState(false);
    const [ loading, setLoading ] = useState(false);

    // const [ block, setBlock ] = useState('');
    const [ blockId, setBlockId ] = useState('');
    const [ openBlock, setOpenBlock ] = useState(false);

    // const [ posts, setPosts ] = useState(state.posts);

    const [ post, setPost ] = useState(state ? state.post : {
                            key:'',
                            caption:'',
                            media: {
                              type: '',
                              url: ''
                            },
                            user: {
                              _id: '',
                              username: '',
                              email: '',
                              accountType: '',
                              emailVerified: null,
                              deleted: null,
                              createdAt: '',
                              updatedAt: '',
                              __v: 0,
                              id: ''
                            },
                            profile: {
                              profileImage: {
                                publicId: '',
                                type: '',
                                url: ''
                              },
                              _id: '',
                              userId: '',
                              deleted: null,
                              createdAt: '',
                              updatedAt: '',
                              __v: 0,
                              firstName: '',
                              gender: '',
                              lastName: '',
                              phone: '',
                              id: ''
                            },
                            location:{
                              name: '',
                              coordinates: [0, 0]
                            },
                            id: '',
                            createdAt: null,
                            posts: [],
                            likedBy: [],
                            likes: 0,
                            pinnedBy: [],
                            params: {
                                page: 0, limit: 6, sort: "-createdAt",
                            },
                            setParams: null,
                            total: 0
    })

    // console.log(useParams())
    const params = useParams()


    
    const _posts = state.posts.slice( state.posts.findIndex((ps: { _id: any; }) =>ps._id === post.id) )

    const itemSize = height
    const itemCount = _posts.length
    const handleScroll = useCallback(() => {
        if (!listRef.current) return;
        const { scrollTop, clientHeight } = listRef.current._outerRef as HTMLElement;
        const lastItemOffset = itemSize * (itemCount - 1);
        const maxScrollTop = lastItemOffset - clientHeight;
        if (scrollTop >= maxScrollTop) {
          setIsLastVideoVisible(true);
          
        } else {
          setIsLastVideoVisible(false);
        }
    }, [itemCount, itemSize]);

    useEffect(()=>{

        //
        const handleResize = () =>  {
            setHeight(window.innerHeight)
            setWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize);

      if (!state &&  !_.isEmpty(params) ) {
        //
        Auth.api.get('/posts/'+params.id).then(res=>{
          //
          setPost(res.data.data)
          console.log(res.data.data)
        })
  
      } 
      else if (state) {

      }
      else {
        //
        navigate('/')
        return;
      }

      const ref = listRef.current;
      if (ref) {
        ref._outerRef.addEventListener("scroll", handleScroll);
      }
      return () => {
        if (ref) {
          if (ref._outerRef) {
            ref._outerRef.removeEventListener("scroll", handleScroll);
          }
        }

        window.removeEventListener('resize', handleResize)
      }

    //   console.log('main',height)

    }, [handleScroll, height, navigate, params, setPost, state])

    const unMute = () => {
        //
        if (mute) {
          setMute(false)
  
          Auth.setMuted('false')
        } else {
          setMute(true)
          Auth.setMuted('true')
        }
    }

    const sharePost = async (id: string, caption: string) => {

        if (_.isEmpty(Auth.getUser())) {
          navigate('/login')
          return;
        } 
  
        const shareData = {
          title: `Wherespoppin - ${caption}`,
          text: `${caption}`,
          url: `https://wherespoppin.app/post/${id}`,
        };
        //
        await navigator.share(shareData);
      }
  
      const [ open, setOpen ] = useState(false)
  
      // console.log(post)
  
      const likePost = (id: string, i: number) => {
        
        if (_.isEmpty(Auth.getUser())) {
          navigate('/login')
          return;
        } 
  
        Auth.api.get("/posts/like/"+id).then(res=>{
  
          // toast.success(res.data.message, {
          //   position: "top-center",
          // });
          const data = JSON.parse(JSON.stringify(res.data.data))
          data.pinnedBy = data.pinnedBy ? data.pinnedBy : []
          data.user = state.post.user
          data.profile = state.post.profile
  
          _posts[i] = data
          // post.likedBy = res.data.data.likedBy
          // post.likes =  res.data.data.likedBy
  
        }).catch(err=>{
          
          console.log(err)
          
            // toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
            //   position: "top-center",
            // });
        })
  
      }
  
      const pinPost = (id: string, i: number) => {
  
        if (_.isEmpty(Auth.getUser())) {
          navigate('/login')
          return;
        } 
        //
        Auth.api.post("/pins/", { postId: id, userId: Auth.getUser()._id }).then(res=>{
  
          // toast.success(res.data.message, {
          //   position: "top-center",
          // });
          // console.log(res.data.data)
          Auth.api.get('/posts/'+id).then(res=>{
            
            const data = JSON.parse(JSON.stringify(res.data.data))
  
            data.pinnedBy = data.pinnedBy ? data.pinnedBy : []
            data.user = state.post.user
            data.profile = state.post.profile
            // 
            _posts[i] = data
            // setPost(data)
          })
          
  
        }).catch(err=>{
          
          console.log(err)
          
            // toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
            //   position: "top-center",
            // });
        })
      }
  
      const deletePost = (id: any) => {
        
        if (_.isEmpty(Auth.getUser())) {
          navigate('/login')
          return;
        } 

        
  
        Auth.api.delete("/posts/"+id).then(res=>{
  
          // toast.success(res.data.message, {
          //   position: "top-center",
          // });
          
          // console.log(res.data.data)
          // navigate(-1)

          // clear cache
          Auth.clearPostCached();
          
          setTimeout(()=>{
            navigate(-1)
          }, 600);
  
        }).catch(err=>{
          
            console.log(err)
          
            // toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
            //   position: "top-center",
            // });
        })
      }

      const blockUser = () => {

        if (blockId) {
          Auth.api.get('/users/block/'+blockId).then(res => {
  
            // console.log(res.data)
  
  
            //  setup vendor
            // Auth.setVendor(res.data.data)
            setLoading(true)
            // setTimeout(()=>{
            //   // navigate 
            //   navigate('/vendor')
            // }, 1800)

            Auth.clearPostCached();
  
            toast.success(res.data.message, {
              position: "top-center",
            });
            
            setTimeout(()=>{
              navigate(-1)
            }, 600);
            // navigate(-1)
  
          }).catch(err=>{
  
            console.log(err)
  
            // setLoading(false)
  
            if (_.isArray(err.response.data.error)) {
              let error = err.response.data.error
              //
              for (let index = 0; index < error.length; index++) {
                const err = error[index];
                toast.error(err.message, {
                  position: "top-center",
                });
              }
            } else {
              toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
                position: "top-center",
              });
            }
  
          })
  
          setOpenBlock(false)
        }
      }

    const fetchData = () => {
      //
      if (_posts.length >= post.total) {
          // setMore(false)
          return;
      }
      post.params.page++

      console.log(post.params)

      Auth.api.get("/posts", { params: post.params} ).then(res=> {
          //

          // setPost(res.data.data)

          // const data = { total: res.data.data.total, pages: res.data.data.pages, page: _page, limit: _limit, data: [...post.data, ...res.data.data.data] }

            return res.data.data;
          
        })
        .catch(err=>{
    
          console.log(err)
          
          // toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
          //   position: "top-center",
          // });
  
      })
  
    }

    const handleReportSubmit = (event: any) => {
        
      event.preventDefault();
      
      setLoading(true)

      if (reportId) {

        Auth.api.post("/reports/", { postId: reportId, reason: report } ).then(res=>{
    
          toast.success(res.data.message, {
            position: "top-center",
          });
          
          // console.log(res.data.data)
          // navigate(-1)
          setOpenReport(false)
          setLoading(false)


        }).catch(err=>{
          
            console.log(err)
          
            toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
              position: "top-center",
            });
            
            setLoading(false)
        })
      }
    }

    // console.log(_posts)

    // const Posts = ({ index, style }: any) => (

    //     // <div style={style}>Row {index}</div>

    //     <PostViewComponent 
    //             height={height}
    //             width={width}
    //             style={style}
    //             key={_posts[index].id}
    //                 caption={''} 
    //                 media={_posts[index].media} 
    //                 user={_posts[index].user} 
    //                 profile={_posts[index].profile} 
    //                 location={_posts[index].location} 
    //                 id={_posts[index].id} 
    //                 vendor={_posts[index].vendor}
    //                 createdAt={_posts[index].createdAt}
    //                 meta={_posts[index].meta}
    //                 user_action={_posts[index].user_action}
    //                 posts={_posts}
    //                 likedBy={_posts[index].likedBy}
    //                 likes={_posts[index].likes}
    //                 pinnedBy={_posts[index].pinnedBy}
    //                 mute={mute}
    //                 setMute={setMute}
    //         />
    // );


    // const Posts = ({ index, style }: any) => (

    //     // <div style={style}>Row {index}</div>
    //     <div className='h-screen'> 
    //             <video muted={mute}  className="h-screen object-cover"> 
    //                 <source src={_posts[index].media.url+'#t=0.001'} type='video/mp4'></source>
    //             </video> 
    //     </div>
    //     // <PostViewComponent 
    //     //         height={height}
    //     //         width={width}
    //     //         style={style}
    //     //         key={_posts[index].id}
    //     //             caption={''} 
    //     //             media={_posts[index].media} 
    //     //             user={_posts[index].user} 
    //     //             profile={_posts[index].profile} 
    //     //             location={_posts[index].location} 
    //     //             id={_posts[index].id} 
    //     //             vendor={_posts[index].vendor}
    //     //             createdAt={_posts[index].createdAt}
    //     //             meta={_posts[index].meta}
    //     //             user_action={_posts[index].user_action}
    //     //             posts={_posts}
    //     //             likedBy={_posts[index].likedBy}
    //     //             likes={_posts[index].likes}
    //     //             pinnedBy={_posts[index].pinnedBy}
    //     //             mute={mute}
    //     //             setMute={setMute}
    //     //     />
    // );

    // const postsItems = _posts.map(
        
    //   (post: Post) =>
             
    //         <PostViewComponent 
    //             key={post.id}
    //                 caption={post.caption} 
    //                 media={post.media} 
    //                 user={post.user} 
    //                 profile={post.profile} 
    //                 location={post.location} 
    //                 id={post.id} 
    //                 vendor={post.vendor}
    //                 createdAt={post.createdAt}
    //                 meta={post.meta}
    //                 user_action={post.user_action}
    //                 posts={_posts}
    //                 likedBy={post.likedBy}
    //                 likes={post.likes}
    //                 pinnedBy={post.pinnedBy}
    //                 mute={mute}
    //                 setMute={setMute}
    //               />
           
        
    // )


    const openOptions = (data: { id: any, user: any }) => {
        //
        post.id = data.id
        post.user = data.user

        const info = data;
        setPost(info)

        setOpen(true)
    }
    // alert((document.documentElement.clientHeight)+' '+height)
    
      
    
    return (
      <div>
         
        { loading ? <PageLoader /> : '' }
         <IconBackComponent />
        {/* <InfiniteScroll
                dataLength={_posts.data.length}
                hasMore={true}
                next={fetchData}
                loader={<p className='text-center'></p>}
                > */}


<InfiniteLoader
      isItemLoaded={_posts.length}
      itemCount={itemCount}
      loadMoreItems={fetchData}
    >
      {({ onItemsRendered, ref }) => (
                
                <List
                    ref={listRef}
                    height={height}
                    itemCount={_posts.length}
                    itemSize={height}
                    width={width}
                    overscanCount={0}
                    style={{ scrollSnapType: "y mandatory", overflowY: "scroll" }}
                >
                    {({ index, style }: any) => (
                    <div id={_posts[index].id} style={{
                        ...style,
                        scrollSnapAlign: "start",
                        scrollSnapStop: "always",
                      }} className='h-screen'  onDoubleClick={e=>pinPost(_posts[index].id, index)} > 
                      
                      <div id={'vidl'+_posts[index].id} className="invisible absolute top-0 ">
                            <div className="flex items-center">
                            {/* <span className="text-3xl mr-4">Loading</span> */}
                            {/* <svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-black" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg> */}
                            <svg className="animate-spin h-8 w-8 text-gray-800" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                            </div>
                        </div>
                        <div className='relative z-20'>
                            <div className='absolute end-6 bottom-16 space-y-3 flex flex-col mb-20 z-20'>
                                {/* like */}
                                <button className='transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:text-red-500 duration-300' onClick={e=>likePost(_posts[index].id, index)}>
                                    <div  style={{width:'40px', height: '40px'}} className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full">
                                        {/* <button className="items-center"> */}
                                        { _posts[index].likedBy.includes(Auth.getUser()._id) ?
                                        
                                        <svg className="w-5 h-5 transition ease-in-out delay-150 hover:scale-110 hover:text-red-500 duration-300 text-red-500" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="FavoriteIcon"><path d="m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z"></path></svg>
                                        :
                                        <svg className="w-5 h-5 transition ease-in-out delay-150 hover:scale-110 hover:text-red-500 duration-300" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="FavoriteBorderOutlinedIcon"><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3m-4.4 15.55-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05"></path></svg>
                                        }
                                        {/* </button> */}
                                    </div>
                                </button>
                                {/* pin */}
                                <span style={{marginTop: "0"}} className='pt-2 text-center text-white text-xs font-medium'>{_posts[index].likes}</span>
                                <button className='' onClick={e=>pinPost(_posts[index].id, index)}>
                                    <div  style={{width:'40px', height: '40px'}} className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full">
                                    { _posts[index].pinnedBy.includes(Auth.getUser()._id) ?
                                    <svg fill='currentColor' className="w-5 h-5" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="BookmarkIcon"><path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2"></path></svg>
                                    :
                                    <svg fill='currentColor' className="w-5 h-5" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="BookmarkBorderOutlinedIcon"><path d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2m0 15-5-2.18L7 18V5h10z"></path></svg>
                                    }
                                    </div>
                                </button>
                                {/* <IconShareComponent /> */}
                                <button onClick={e=> sharePost(_posts[index].id, ('caption' in _posts[index] ? _posts[index].caption : ''))}>
                                    <div style={{width:'40px', height: '40px'}} className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full">
                                        <svg fill='currentColor' className="w-5 h-5" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="IosShareOutlinedIcon"><path d="m16 5-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2"></path></svg>
                                    </div>
                                </button>

                                <button onClick={e=> openOptions(_posts[index])}>
                                    <div style={{width:'40px', height: '40px'}} className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full">
                                        <svg fill='currentColor' className="w-5 h-5" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="MoreHorizOutlinedIcon"><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"></path></svg>
                                    </div>
                                </button>
                            </div>
                            <div className='flex flex-col absolute bottom-9 space-y-2 left-6 z-30'>
                                <div className='flex flex-row items-center space-y-1 relative'>
                                    <NavLink to={Auth.getUser()._id === _posts[index].user._id ? '/profile' : '/user-profile'} state={{ user: { _id: _posts[index].user._id, username: _posts[index].user.username, profile: _posts[index].profile } }}>
                                        {(_posts[index].profile.profileImage) &&
                                                        
                                        <div style={{width:'55px', height: '55px'}} className="border bg-gray-100 border-slate-400 rounded-full">
                                            <div className="bg-white block rounded-full  hover:-rotate-6 transform transition">
                                                    <img alt='profile' className='rounded-full object-cover aspect-square p-0.5' src={_posts[index].profile.profileImage.url}/>
                                            </div>
                                        </div>
                                                        
                                        }
                                        { !(_posts[index].profile.profileImage) &&
                                            <Avatar round={true} size='55' name={_posts[index].profile.firstName+' '+_posts[index].profile.lastName} />
                                        }
                                    </NavLink>
                                    <div className='ml-4 text-left  '>
                                        <h2 className='text-md font-bold mb-0 text-white pb-0'>{_posts[index].user.username }</h2>
                                        <p className='text-sm text-gray-500 text-white mb-0 pb-0'>
                                            <ReactTimeAgo date={new Date(_posts[index].createdAt)} locale="en" />
                                        </p>
                                    </div>
                                    </div>
                                    
                                    {'location' in _posts[index] ?
                                    <div>
                                      { 'caption' in _posts[index] &&
                                        <p className='text-sm text-white text-left px-1 pb-1.5'>{_posts[index].caption}</p>
                                      }
                                      {'location' in _posts[index] ? 
                                        <div>
                                          {_posts[index].location.name.length > 30 ?

                                          <div className='text-white flex justify-left align-center text-xs p-1 text-left px-2 bg-gray-500/80 rounded-full max-w-64'>
                                              <svg className="w-9 flex align-self-center mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="MyLocationIcon"><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7"></path></svg>

                                              {/* <svg className="w-4 h-4 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="LocationOnIcon"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"></path></svg> */}

                                              <span className='pr-2 flex align-self-center py-1'><Marquee>{_posts[index].location.name}</Marquee></span>
                                          </div>

                                          : 
                                          
                                          <div className='text-white flex justify-left align-center text-xs p-1 text-left px-2 bg-gray-500/80 rounded-full'>
                                              <svg className="w-4 flex align-self-center mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="MyLocationIcon"><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7"></path></svg>

                                              {/* <svg className="w-4 h-4 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="LocationOnIcon"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"></path></svg> */}
                                              <span className='pr-2 flex align-self-center py-0.5'>{_posts[index].location.name}</span>
                                              
                                              
                                          </div>
                                          }
                                        </div>
                                        : '' }
                                    </div>
                                    
                                    : 
                                    
                                    <div>
                                      { 'caption' in _posts[index] &&
                                        <p className='text-sm text-white text-left px-1 pb-1.5'>{_posts[index].caption}</p>

                                      }
                                    </div>
                                    }
                                </div>
                            {_posts[index].media.type === 'image' ?
                
                                <img alt={'caption' in _posts[index] ? _posts[index].caption : ''}  className='h-screen object-cover' src={_posts[index].media.url}></img>
                            :
                                _posts[index].media.type === 'video' ?
                                
                                // <AdvancedVideo onLoadStart={(e)=> {(document.getElementById('vidl'+_posts[index].id) as HTMLDivElement).className = 'absolute bg-opacity-60 z-40 h-full w-full flex items-center justify-center dark:bg-black dark:bg-opacity-60' } } onLoadedData={e=>{(document.getElementById('vidl'+_posts[index].id) as HTMLDivElement).className = 'invisible absolute top-0';}} poster={getVideoThumb(_posts[index].media.url)} onClick={e=> unMute()} id={'vid'+_posts[index].id} ref={ref}  playsInline={true} loop muted={mute} className="h-screen object-cover"
                                //   cldVid={cld.video(getMediaStreamVideoURL(_posts[index].media.url)).quality('auto:eco')}/>

                                <video onLoadStart={(e)=> {(document.getElementById('vidl'+_posts[index].id) as HTMLDivElement).className = 'absolute bg-white bg-opacity-60 z-40 h-full w-full flex items-center justify-center dark:bg-black dark:bg-opacity-60' } } onLoadedData={e=>{(document.getElementById('vidl'+_posts[index].id) as HTMLDivElement).className = 'invisible absolute top-0';}} poster={getVideoThumb(_posts[index].media.url)} onClick={e=> unMute()} id={'vid'+_posts[index].id} ref={ref}  playsInline={true} loop muted={mute} className="h-screen object-cover"> 
                                    <source src={getMediaStreamURL(_posts[index].media.url)} type='video/mp4'></source>
                                    {/* <source src={getMediaStreamURL(_posts[index].media.url)+'#t=0.001'} type='video/mp4'></source> */}
                                    {/* <source src={_posts[index].media.url+'#t=0.001'} type='video/ogg'></source> */}
                                </video>
                            :
                            ''
                            }
                        </div>
                        <div style={{marginTop:'-80px'}} className=' '>
                            <ViewportBlock onEnterViewport={() => { (document.getElementById('vid'+_posts[index].id) as HTMLVideoElement)?.play() }} onLeaveViewport={() => { (document.getElementById('vid'+_posts[index].id) as HTMLVideoElement)?.pause();}} />
                        </div>
                    </div>
                    )}
                </List> 
      )}
      </InfiniteLoader>
                  {/* {postsItems} */}
                  <Dialog open={open} onClose={setOpen} className="relative z-30">
                            <DialogBackdrop
                            transition
                            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                            />

                            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                            <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                                <DialogPanel
                                transition
                                className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95  dark:bg-gray-800 dark:text-white"
                                >
                                <div className="w- text-gray-900 bg-white rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white p-6">
                                    
                                {post.user._id !== Auth.getUser()._id 

                                    ? 

                                    <button onClick={e=> {setOpen(false); setOpenBlock(true); setBlockId(post.user._id) }} type="button" className=" relative inline-flex items-center w-full px-4 py-2 font-medium text-red-500 rounded-b-lg bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400  dark:bg-black focus:text-gray-400  dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                                        <svg className="h-5 w-5 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="BlockIcon"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12m8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8"></path></svg>
                                            <p className='font-medium text-xs'>Block this Account</p>
                                                        
                                    </button>

                                    : ''
                                  }

                                    {post.user._id === Auth.getUser()._id ?
                                        <button onClick={e=>deletePost(post.id)} type="button" className="relative inline-flex items-center w-full px-4 py-2 font-medium text-red-500 rounded-t-lg  bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400  dark:border-gray-600 dark:bg-black dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                                        <svg className="h-5 w-5 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="DeleteIcon"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"></path></svg>
                                        {/* <svg className="h-5 w-5 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ReportGmailerrorredIcon"><path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27zM19 14.9 14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1z"></path><path d="M11 7h2v6h-2zm0 8h2v2h-2z"></path></svg> */}
                                                <p className='font-medium text-xs'>Delete post</p>
                                                        
                                        </button>
                                        : 
                                       <button onClick={e=> {setOpen(false); setOpenReport(true); setReportId(post.id) }} type="button" className=" relative inline-flex items-center w-full px-4 py-2 font-medium text-red-500 rounded-b-lg bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400  dark:bg-black focus:text-gray-400  dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                                          <svg className="h-5 w-5 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ReportGmailerrorredIcon"><path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27zM19 14.9 14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1z"></path><path d="M11 7h2v6h-2zm0 8h2v2h-2z"></path></svg>
                                              <p className='font-medium text-xs'>Report post</p>
                                                          
                                      </button>
                                    }

                                    
                                    
                                </div>
                                </DialogPanel>
                            </div>
                            </div>
                        </Dialog>

                        <Dialog open={openReport} onClose={setOpenReport} className="relative z-20">
                                    <DialogBackdrop
                                      transition
                                      className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                                    />
                        
                                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                                      <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                                        <DialogPanel
                                          transition
                                          className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:text-white"
                                        >
                                          <form onSubmit={handleReportSubmit} className="space-y-4 p-6 w-full">
                                                  <div className='pt-2 px-2  text-left'>
                                                    <p className='text-sm font-medium'> Reason</p>
                                                  </div>
                                                  <div className=''>
                                                    <textarea minLength={5} name="report" id="displayName" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setReport(e.target.value) } placeholder="Reason for reporting" value={report} required={true}></textarea>
                                                    
                                                  </div>
                                                  {/* <div>
                                                    <input type="text" minLength={4} name="fullname" id="fullname" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setFullname(e.target.value) } placeholder="Firstname Lastname" value={fullname} required={true}/>
                                                  </div>
                                                  <div className='grid grid-cols-3 gap-4'>
                                                    <div>
                                                        <input type="text" name="country" id="country" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setCountry(e.target.value) } placeholder="Country" value={country} required={true}/>
                                                    </div>
                                                    <div className='col-span-2'>
                                                        <input type="tel" name="phone" id="phone" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setPhone(e.target.value) } placeholder="Phone" value={phone} required={true}/>
                                                    </div>
                                                  </div> */}
                                                  <div className='flex flex-col space-y-4 '>
                                                    <button type="submit" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Report</button>
                                                    
                                                  </div>
                                            </form>
                                          {/* <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                            <button
                                              type="button"
                                              onClick={() => setOpen(false)}
                                              className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                            >
                                              Deactivate
                                            </button>
                                            <button
                                              type="button"
                                              data-autofocus
                                              onClick={() => setOpen(false)}
                                              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                            >
                                              Cancel
                                            </button>
                                          </div> */}
                                        </DialogPanel>
                                      </div>
                                    </div>
                                  </Dialog>


                                  <Dialog open={openBlock} onClose={setOpenBlock} className="relative z-20">
                                    <DialogBackdrop
                                      transition
                                      className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                                    />
                        
                                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                                      <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                                        <DialogPanel
                                          transition
                                          className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:text-white"
                                        >
                                          <div className="space-y-4 p-6 w-full">
                                              <div className='pt-2 px-2  text-left'>
                                                <p className='text-sm font-medium'> Are you sure you want to "Block this Account"?</p>
                                              </div>
                                              {/* <div>
                                                <input type="text" minLength={4} name="fullname" id="fullname" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setFullname(e.target.value) } placeholder="Firstname Lastname" value={fullname} required={true}/>
                                              </div>
                                              <div className='grid grid-cols-3 gap-4'>
                                                <div>
                                                    <input type="text" name="country" id="country" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setCountry(e.target.value) } placeholder="Country" value={country} required={true}/>
                                                </div>
                                                <div className='col-span-2'>
                                                    <input type="tel" name="phone" id="phone" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setPhone(e.target.value) } placeholder="Phone" value={phone} required={true}/>
                                                </div>
                                              </div> */}
                                              <div className='flex flex-col space-y-4 '>
                                                <button onClick={e=> { setOpenBlock(false);setBlockId('') }} type="button" className="w-full rounded-full text-dark bg-whoite hover:bg-gray-50 border border-slate-300 focus:ring-4 border-slate-500 focus:outline-none focus:ring-primary-300 font-medium text-sm px-5 py-4 text-center dark:bg-black dark:hover:bg-gray-800 dark:focus:ring-primary-800 dark:hover:border-gray-400 dark:border-black">No, Cancel</button>
                    
                                                <button onClick={e=>blockUser()} type="button" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Yes Block </button>
                                                
                                              </div>
                                        </div>
                                          {/* <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                            <button
                                              type="button"
                                              onClick={() => setOpen(false)}
                                              className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                            >
                                              Deactivate
                                            </button>
                                            <button
                                              type="button"
                                              data-autofocus
                                              onClick={() => setOpen(false)}
                                              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                            >
                                              Cancel
                                            </button>
                                          </div> */}
                                        </DialogPanel>
                                      </div>
                                    </div>
                                  </Dialog>
                <ToastContainer />
                {isLastVideoVisible}
        {/* </InfiniteScroll> */}
      </div>
    );
  }
  
  export default PostView;
  

